import { Hourglass } from "lucide-react";

export function NarrativeRegenerationStatus() {
	return (
		<output
			aria-live="polite"
			className="flex min-w-0 items-center gap-2 text-muted-foreground"
		>
			<Hourglass
				aria-hidden="true"
				className="narrative-hourglass size-3.5 shrink-0 text-primary"
			/>
			<span className="truncate">Regenerating narrative…</span>
		</output>
	);
}
